import React from 'react'
import styled, { CSSObject } from '../themes/styled'
import Text, { TextColor, TextScale } from '../Text'
import Icon, { IconColor, IconSize } from '../Icon'

export type LoaderSize = 's' | 'm' | 'l'

interface LoaderProps {
    label?: string
    size?: LoaderSize
    labelColor?: TextColor
    spinnerColor?: IconColor
    className?: string
}

interface LoaderContainerProps {
    size: LoaderSize
}

const sizeMap: Record<LoaderSize, { iconSize: IconSize; textScale: TextScale; style: CSSObject }> = {
    l: {
        iconSize: '24px',
        textScale: 'bodyM500',
        style: {
            padding: '8px 16px',
        },
    },
    m: {
        iconSize: '20px',
        textScale: 'bodyS500',
        style: {
            padding: '6px 16px',
        },
    },
    s: {
        iconSize: '16px',
        textScale: 'bodyS500',
        style: {
            padding: '4px 8px',
        },
    },
}

const LoaderContainer = styled.div<LoaderContainerProps>`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[200]};
    ${({ size }) => sizeMap[size].style}
`

const SectionLoader: React.FC<LoaderProps> = ({ label, labelColor, size = 's', spinnerColor, className }) => {
    const sectionLoaderSize = sizeMap[size]
    return (
        <LoaderContainer size={size} className={className}>
            <Icon
                className="sectionLoader-icon"
                name="loadingSpinner"
                size={sectionLoaderSize.iconSize}
                color={spinnerColor}
            >
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="2s"
                    from="0 0 0"
                    to="360 0 0"
                    repeatCount="indefinite"
                />
            </Icon>
            {label && (
                <Text className="sectionLoader-label" scale={sectionLoaderSize.textScale} color={labelColor}>
                    {label}
                </Text>
            )}
        </LoaderContainer>
    )
}

export default SectionLoader
